/** Hold duration before `openItem` runs on mobile (table row + gallery tile). */
export const ASSET_LIBRARY_LONG_PRESS_MS = 450;
